<template>
  <div>
    <v-autocomplete
      :items="options"
      item-text="name"
      item-value="id"
      hide-details="auto"
      :disabled="disabled"
      :label="$t('tasks.campaign.filter.group.title')"
      :value="value"
      @input="input"
      outlined
      dense
    />
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: [Object, String, Number],
        default: () => {}
      },
      options: {
        type: [Object, Array],
        default: () => []
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      input(val) {
        this.$emit('input', val);
      }
    }
  };
</script>
